import {Component, Inject, OnDestroy, OnInit} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogTitle, MatDialogClose, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { FlexModule } from '@angular/flex-layout';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { NgIf } from '@angular/common';
import { PdfViewerComponent } from '../../editors/pdf-viewer/pdf-viewer.component';

export interface FaxPreviewDialogData {
  pdfSource: string;
}

@Component({
    selector: 'app-fax-preview-dialog',
    templateUrl: './fax-preview-dialog.component.html',
    styleUrls: ['./fax-preview-dialog.component.scss'],
    standalone: true,
    imports: [
        FlexModule,
        MatDialogTitle,
        MatIconButton,
        MatDialogClose,
        MatIcon,
        CdkScrollable,
        MatDialogContent,
        NgIf,
        PdfViewerComponent,
        MatDialogActions,
        MatButton,
    ],
})
export class FaxPreviewDialogComponent implements OnInit, OnDestroy {

  constructor(public dialogRef: MatDialogRef<FaxPreviewDialogComponent>,
              public dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: FaxPreviewDialogData) {
  }

  afterPdfLoaded() {
    window.dispatchEvent(new Event('resize'));
  }

  ngOnInit() {
    console.log('Fax preview init', this.data);
  }

  ngOnDestroy() {
  }
}
